import { default as actionCreatorFactory } from 'typescript-fsa';
import { ActivityStart } from '../../utils';

const actionCreator = actionCreatorFactory('embedding');

export const widgetReady = actionCreator('WIDGET_READY');
export const activityStart = actionCreator<ActivityStart>('ACTIVITY_START');
export const activityStop = actionCreator('ACTIVITY_STOP');
export const warnTooSmall = actionCreator<boolean>('WARN_TOO_SMALL');

interface User {
  userId: string;
}

export const userAdded = actionCreator<User>('USER_ADDED');
